module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "done-tasks-dashboard"
    }
  }, [_c('h2', [_vm._v("Tarefas executadas")]), _c('br'), _c('div', {
    staticClass: "row same-height-columns"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "total-quantity blue-block"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.total_quantity))]), _c('div', {
    staticClass: "legend"
  }, [_vm._v("Total")])]), _c('div', {
    staticClass: "service-quantity-wrapper"
  }, _vm._l((_vm.done_tasks_list), function(task_data) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "service-quantity blue-block"
    }, [_c('div', {
      staticClass: "number"
    }, [_vm._v(_vm._s(task_data[1]))]), _c('div', {
      staticClass: "icon icon-green",
      class: task_data[2]
    })])])
  }), 0)]), _c('div', {
    staticClass: "col-sm-1"
  }), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "row full-height"
  }, _vm._l((_vm.done_tasks_list), function(task_data) {
    return _c('div', {
      staticClass: "col-sm-3 full-height vertical-bar-wrapper"
    }, [_c('vertical-bar', {
      attrs: {
        "total": _vm.total_quantity,
        "value": task_data[1],
        "icon_class": task_data[2] + " icon-green"
      }
    })], 1)
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bf602af!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/done_tasks.vue
// module id = 1033
// module chunks = 1